/**
 * Maps `react-device-detect` signals to session metadata for login.
 */

import {
    browserName,
    browserVersion,
    isMobile,
    isTablet,
    osName,
    osVersion,
} from "react-device-detect";

/** Coarse device class persisted on `user_sessions`. */
export type DeviceType = "mobile" | "desktop" | "tablet";

/** Client metadata sent with `POST /api/auth/login`. */
export interface DeviceMetadata {
    "device_type": DeviceType;
    "browser":     string;
    "os":          string;
}

/**
 * Builds device / browser / OS labels for the login request body.
 *
 * @returns Metadata object for the auth API.
 */
export function getDeviceMetadata(): DeviceMetadata {
    const deviceType: DeviceType = isTablet
        ? "tablet"
        : isMobile
            ? "mobile"
            : "desktop";

    const browserLabel = [ browserName, browserVersion ].filter( ( part ) => {
        return typeof part === "string" && part.trim() !== "";
    } ).join( " " );

    const osLabel = [ osName, osVersion ].filter( ( part ) => {
        return typeof part === "string" && part.trim() !== "";
    } ).join( " " );

    return {
        "device_type": deviceType,
        "browser":     browserLabel === "" ? "unknown" : browserLabel,
        "os":          osLabel === "" ? "unknown" : osLabel,
    };
}
